<h1 mat-dialog-title>{{ isEdit ? 'Edit' : 'Add' }} User</h1>

<form [formGroup]="formGroup" (submit)="save()">
	<mat-dialog-content class="container">
		<div class="row">
			<div class="col d-flex align-items-center justify-content-center mb-4">
				<dix-profile-picture-selector
					[hideEditButton]="formGroup.controls.email.touched && !!(preExistingUser$ | async)"
					[identifier]="formGroup.controls.email.touched && preExistingUserId ? preExistingUserId : data.id"
				></dix-profile-picture-selector>
			</div>
			<div class="col col-8">
				<div class="row">
					<div class="col">
						<mat-form-field class="w-100" appearance="outline">
							<mat-label>First Name</mat-label>
							<input [formControl]="formGroup.controls.name" matInput />
							@if (formGroup.controls.name.errors?.required) {
								<mat-error>First Name is required</mat-error>
							}
						</mat-form-field>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<mat-form-field class="w-100" appearance="outline">
							<mat-label>Last Name</mat-label>
							<input [formControl]="formGroup.controls.lastName" matInput />
							@if (formGroup.controls.lastName.errors?.required) {
								<mat-error>Last name is required</mat-error>
							}
						</mat-form-field>
					</div>
				</div>
			</div>
		</div>
		@if (!data?.existing) {
			<div class="row">
				<div class="col">
					<mat-form-field class="w-100" appearance="outline">
						<mat-label>Email</mat-label>
						<input [formControl]="formGroup.controls.email" matInput />
						@if (formGroup.controls.email.errors?.required) {
							<mat-error>Email is required</mat-error>
						}
						@if (formGroup.controls.email.errors?.email) {
							<mat-error>Invalid email</mat-error>
						}
						@if (formGroup.controls.email.errors?.exists) {
							<mat-error>
								@if (data.clientId) {
									A user with this email already has access to this client
								}
								@if (!data.clientId) {
									This email is already in use
								}
							</mat-error>
						}
						@if ((preExistingUser$ | async) && !formGroup.controls.email.errors?.exists) {
							<mat-hint> A user with that email already exists, you can add them to this client. </mat-hint>
						}
					</mat-form-field>
				</div>
			</div>
		}
		@if (isAdmin && activeUserId !== data.id) {
			<div class="row mt-1">
				<div class="col">
					<mat-form-field class="w-100" appearance="outline">
						<mat-label>Role</mat-label>
						<mat-select formControlName="role">
							@for (role of roles; track role) {
								<mat-option [value]="role">
									{{ role | formatEnum }}
								</mat-option>
							}
						</mat-select>
						@if (formGroup.controls.role.errors?.required) {
							<mat-error>Role is required</mat-error>
						}
					</mat-form-field>
				</div>
			</div>
		}
		<div class="row">
			<div class="col">
				<mat-checkbox formControlName="sendWelcomeEmail">Send activation email.</mat-checkbox>
			</div>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions align="end">
		<div class="d-flex gap-2 align-self-end">
			<button mat-button mat-dialog-close>Cancel</button>
			<button mat-flat-button color="primary" type="submit">
				{{ isEdit ? 'Update' : 'Add' }}
			</button>
		</div>
	</mat-dialog-actions>
</form>
